import React, {useEffect} from 'react'
import {Arrow, KonvaNodeEvents, Layer, Text} from 'react-konva'
import {Node as NodeRef} from 'konva/lib/Node'
import {useStateWithRef} from '../../../hooks/useStateWithRef'
import {getRelativePointerPosition} from '../util'

export type RulerLayerProps = {
  canvasPixelsPerM: number
  setCursor: (cursor: string) => void
  resetCursor: () => void
}

export function RulerLayer(props: RulerLayerProps) {
  const layerRef = React.useRef<NodeRef>(null)

  const [startPoint, setStartPoint, startPointRef] = useStateWithRef<{
    x: number
    y: number
  } | null>(null)
  const [endPoint, setEndPoint, endPointRef] = useStateWithRef<{
    x: number
    y: number
  } | null>(null)

  const length =
    startPoint && endPoint
      ? Math.sqrt(
          (startPoint.x - endPoint.x) * (startPoint.x - endPoint.x) +
            (startPoint.y - endPoint.y) * (startPoint.y - endPoint.y)
        )
      : null

  useEffect(() => {
    const onMouseDown: KonvaNodeEvents['onMouseDown'] = (e) => {
      const {x, y} = getRelativePointerPosition(e.target)
      setStartPoint({x, y})
    }

    const onMouseMove: KonvaNodeEvents['onMouseMove'] = (e) => {
      if (!startPointRef.current) {
        return
      }

      const {x: mouseX, y: mouseY} = getRelativePointerPosition(e.target)

      setEndPoint({
        x: mouseX,
        y: mouseY,
      })
    }

    const onMouseUp: KonvaNodeEvents['onMouseUp'] = (e) => {
      setStartPoint(null)
      setEndPoint(null)
    }

    const stage = layerRef.current.getStage()

    stage.on('mousedown', onMouseDown)
    stage.on('mousemove', onMouseMove)
    stage.on('mouseup', onMouseUp)

    return () => {
      if (stage) {
        stage.off('mousedown', onMouseDown)
        stage.off('mousemove', onMouseMove)
        stage.off('mouseup', onMouseUp)
      }
    }
  }, [])

  return (
    <Layer ref={layerRef as any} opacity={0.7}>
      {startPoint && endPoint && (
        <>
          <Arrow
            stroke="black"
            fill="red"
            stsrokeWidth={25 / props.canvasPixelsPerM}
            strokeScaleEnabled={false}
            points={[startPoint.x, startPoint.y, endPoint.x, endPoint.y]}
          />
          <Text
            x={endPoint.x}
            y={endPoint.y}
            text={length.toFixed(2).toString()}
            fontSize={25 / props.canvasPixelsPerM}
          ></Text>
        </>
      )}
    </Layer>
  )
}
